/**
 * 获取数组的前三个元素，组成新数组
 * @param {Array} arr - 源数组
 * @returns {Array} 包含前三个元素的新数组（若源数组长度不足3，则返回所有元素）
 */
export function getFirstThreeElements(arr) {
  if (!Array.isArray(arr)) {
    return []
  }
  return arr.slice(0, 3)
}

export type ReviewStatusData = {
  userId: string // 用户id
  courseId: number | string // 课程id
}

class SumReviewPopStorage {
  static store_key: string = 'study-review-pop'

  // 通过data获取对应拼接的key
  private getStorageKey(data: ReviewStatusData) {
    if (!data.courseId || !data.userId) {
      throw new Error('参数缺失')
    }

    return `${data.userId}:${data.courseId}`
  }

  private getStorage(): Record<string, string> {
    return JSON.parse(localStorage.getItem(SumReviewPopStorage.store_key) || '{}')
  }

  private setStorage(data: Record<string, string>) {
    localStorage.setItem(SumReviewPopStorage.store_key, JSON.stringify(data))
  }

  public setReviewStatusByKey(data: ReviewStatusData) {
    const key = this.getStorageKey(data)
    const value = this.getStorage()
    value[key] = 'true'
    this.setStorage(value)
  }

  public getReviewStatusByKey(data: ReviewStatusData) {
    const key = this.getStorageKey(data)
    const origin_value = this.getStorage()

    return origin_value[key] === 'true'
  }
}

const sumReviewPopStorage = new SumReviewPopStorage()

export default sumReviewPopStorage
